import { difference, union } from '@sama/micro-dash';

export function determineMethod(
  currentSelection: number[],
  indexesToModify: number[],
  setOrToggle: 'set' | 'toggle',
) {
  if (!indexesToModify.length) {
    return 'set';
  }

  const numChanges = difference(indexesToModify, currentSelection).length;

  if (setOrToggle === 'toggle') {
    return numChanges ? 'add' : 'remove';
  } else {
    return numChanges ? 'set' : undefined;
  }
}

export function determineResultingIndexes(
  method: 'add' | 'remove' | 'set' | undefined,
  initialIndexes: number[],
  indexesToModify: number[],
) {
  switch (method) {
    case 'add':
      return union(initialIndexes, indexesToModify);
    case 'remove':
      return difference(initialIndexes, indexesToModify);
    case 'set':
      return indexesToModify;
    case undefined:
      return initialIndexes;
  }
}
